import React from 'react';
import PropTypes from 'prop-types';
import NotificationSystem from 'rc-notification';
import { BasicNotification } from './Notification';

export const showNotification = (
  notificationInstance,
  color,
  title,
  message
) => {
  notificationInstance.notice({
    content: (
      <BasicNotification color={color} title={title} message={message} />
    ),
    duration: 8,
    closable: true,
    style: { top: 15, left: 'calc(100vw - 100%)' },
    className: 'right-up',
  });
};

export const showNotificationAutoDestroy = (color, title, message) => {
  NotificationSystem.newInstance({}, (notification) => {
    notification.notice({
      content: (
        <BasicNotification color={color} title={title} message={message} />
      ),
      duration: 8,
      closable: true,
      style: { top: 15, left: 'calc(100vw - 100%)' },
      className: 'right-up',
      onClose: () => {
        notification.destroy();
      },
    });
  });
};

showNotification.propTypes = {
  notificationInstance: PropTypes.shape({
    notice: PropTypes.func.isRequired,
  }),
  color: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

showNotification.defaultProps = {
  notificationInstance: null,
};
